import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { useSocket } from '../../context/SocketContext';
import { signOutRequest } from '../../store/auth/authSlice';
import { setDirection, setSelectLanguage } from '../../store/language/languageSlice';
import { getUniqueBrowserId } from '../../utils/helpers';
import DesktopHeader from './DesktopHeader';
import { MobileHeader } from './MobileHeader';
import { unsetAllNotification } from '../../store/notification/notificationSlice';

const Header = ({
  backgroundColor,
  containerClass,
  className,
  safeNavigate,
  logo,
  customStyle
}) => {
  const { i18n, t } = useTranslation('webCommon');
  const { user } = useSelector((state) => state?.authReducer);
  const { allCurrency } = useSelector((state) => state?.commonReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const socket = useSocket();

  const [isMobile, setIsMobile] = useState(false);
  const [isScroll, setIsScroll] = useState(false);

  function logout() {
    socket?.current?.emit('logout', { userId: user?._id, deviceId: getUniqueBrowserId() });
    localStorage.removeItem('uniqueBrowserId');
    socket.current.close();
    //! TODO: clear all necessary data [Very Important]
    dispatch(signOutRequest());
    dispatch(unsetAllNotification());

    navigate('/');
  }

  function onScroll() {
    if (window.scrollY > 160) {
      setIsScroll(true);
    } else {
      setIsScroll(false);
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    isMobileViewHook(setIsMobile, 992);
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    dispatch(setSelectLanguage(lng));
    if (['ar', 'fa'].includes(lng)) {
      dispatch(setDirection('rtl'));

      // document.body.dir = i18n.dir();
    } else {
      dispatch(setDirection('ltr'));

      // document.body.dir = i18n.dir("ltr");
    }
  };

  return (
    <>
      {isMobile ? (
        <MobileHeader
          safeNavigate={safeNavigate}
          logo={logo}
          customStyle={customStyle}
          containerClass={containerClass}
          isScroll={isScroll}
          onLogout={logout}
          changeLanguage={changeLanguage}
          t={t}
          allCurrency={allCurrency}
        />
      ) : (
        <DesktopHeader
          logo={logo}
          backgroundColor={backgroundColor}
          containerClass={containerClass}
          className={className}
          isScroll={isScroll}
          onLogout={logout}
          changeLanguage={changeLanguage}
          t={t}
          safeNavigate={safeNavigate}
          allCurrency={allCurrency}
        />
      )}
    </>
  );
};

export default Header;

Header.propTypes = {
  backgroundColor: PropTypes.string,
  containerClass: PropTypes.string,
  className: PropTypes.string,
  logo: PropTypes.object,
  customStyle: PropTypes.object
};
